export const RoutePath = {
  Home: "/",
  About: "/about",
  Contact: "/contact",
  Team: "/team",
  Work: "/how-its-work",
  Services: "/services",
  Panel: "/panel",
  Contact: "/contact",
  BlogCard: "/blog",
  BlogPage: "/blog-page/:id",
  PrivacyPolicy: "/privacy-policy"
};